import { render, staticRenderFns } from "./IzinMain.vue?vue&type=template&id=7b5a467c&scoped=true&"
import script from "./IzinMain.vue?vue&type=script&lang=js&"
export * from "./IzinMain.vue?vue&type=script&lang=js&"
import style0 from "./IzinMain.vue?vue&type=style&index=0&id=7b5a467c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5a467c",
  null
  
)

export default component.exports